var __defProp = Object.defineProperty;
var __getProtoOf = Object.getPrototypeOf;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __superGet = (cls, obj, key) => __reflectGet(__getProtoOf(cls), key, obj);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { NavigationClient } from "@azure/msal-browser";
class MsalNavigationClient extends NavigationClient {
  constructor(history) {
    super();
    __publicField(this, "history");
    this.history = history;
  }
  // @ts-ignores
  navigateInternal(url, options) {
    return __async(this, null, function* () {
      let urlObject;
      try {
        urlObject = new URL(url);
      } catch (err) {
        return __superGet(MsalNavigationClient.prototype, this, "navigateInternal").call(this, url, options);
      }
      const relativePath = urlObject.pathname + urlObject.search + urlObject.hash;
      if (!!this.history) {
        if (options.noHistory) {
          this.history.replace(relativePath);
        } else {
          this.history.push(relativePath);
        }
        return Promise.resolve(false);
      }
    });
  }
}
export {
  MsalNavigationClient
};
//# sourceMappingURL=MsalNavigationClient.js.map
